import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const fundImporterSelectors = importerSelectors(
  'fund.importer',
);

export default fundImporterSelectors;
